<script>
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import Select from "svelte-select";
  import { Circle } from "svelte-loading-spinners";
  import * as ls from "local-storage";

  let uploading = false;

  let genSKU = (name, size = 5) => {
    if (name) {
      let temp = name
        .replaceAll("  ", " ")
        .split(" ")
        .slice(0, size)
        .map((words) => words.slice(0, 3))
        .join("-")
        .replaceAll("--", "-")
        .replaceAll("--", "-")
        .toUpperCase();
      // temp = temp.slice(0, temp.length - 1);
      return temp;
    } else return "";
  };

  let name = null;
  let price = null;
  let inventoryLevel = null;
  let reorderLevel = null;
  let SKU = null;
  let rowN = null;
  let colour = null;
  let description = null;

  let supplier = null;
  let selStockType = null;
  let selStockName = null;

  const handleClear = () => {
    name = null;
    price = null;
    inventoryLevel = null;
    reorderLevel = null;
    SKU = null;
    rowN = null;
    colour = null;
    description = null;
    // ...
    supplier = null;
    selStockType = null;
    selStockName = null;
  };

  const handleSubmit = async (e) => {
    if (
      $config.items.find(({ label }) =>
        $config.f.equals(
          label,
          `${colour || ""}${
            selStockType?.value == "Fabric" ? name : selStockName?.value
          }`
        )
      )
    ) {
      alert("⚠ This Stock Item already exists");
      return;
    }

    // Generate SKU
    if (selStockType && selStockType?.value) {
      if (selStockType.value == "Fabric") SKU = genSKU(name);
      else if (selStockName) SKU = genSKU(selStockName.value);
    }
    // ................
    if (!supplier) alert("Supplier missing!");
    else if (!price) alert("Price missing!");
    // ................
    else if (!selStockType) alert("Stock Type Missing!");
    else if (selStockType?.value == "Fabric" && !name)
      alert("Fabric Name Missing!");
    else if (selStockType?.value == "Consumable" && !selStockName)
      alert("Please Select Consumable!");
    else if (selStockType?.value == "Trim" && !selStockName)
      alert("Please Select Trim!");
    // ................
    else if (inventoryLevel == undefined) alert("Inventory Level missing!");
    else if (reorderLevel == undefined) alert("Reorder Level missing!");
    else if (!SKU) alert("SKU missing!");
    else if (!colour) alert("Colour missing!");
    // ................
    else {
      uploading = true;

      let data = {
        price,
        SKU,
        rowN,
        colour,
        description,
        supplierID: supplier.value,
        stockType: selStockType.value,
        name: selStockType.value == "Fabric" ? name : selStockName.value,
      };

      axios
        .post(`${$config.backendURL}/items`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Added Successfully`);
          window.location.reload();
          handleClear();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Add Item to Stock | Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Add new item to Stock"
    description="Fill out the form below to enter the item details. All fields are REQUIRED."
  />

  <div class="flex justify-end mb-6">
    <a class="btn btn-green-outline" use:link href="/products">
      <i class="fas fa-arrow-left mr-3" />
      Return to Stock
    </a>
  </div>

  <form
    on:submit|preventDefault={handleSubmit}
    class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
  >
    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Select A Supplier :</div>
        <div class="col-span-2">
          <Select
            items={$config.suppliers}
            on:select={(e) => (supplier = e.detail)}
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Unit Price :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          bind:value={price}
          type="number"
          step="any"
          placeholder="Unit Price"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Select Stock Type :</div>
        <div class="col-span-2">
          <Select
            items={$config.stockTypes}
            on:select={(e) => {
              selStockType = e.detail;
              console.log(e.detail.value);
            }}
          />
        </div>
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        {#if selStockType?.value == "Trim"}
          <div>Select Trim :</div>
          <div class="col-span-2">
            <Select
              items={$config.trims}
              on:select={(e) => (selStockName = e.detail)}
            />
          </div>
        {:else if selStockType?.value == "Consumable"}
          <div>Select Consumable :</div>
          <div class="col-span-2">
            <Select
              items={$config.consumable}
              on:select={(e) => (selStockName = e.detail)}
            />
          </div>
        {:else if selStockType?.value == "Fabric"}
          <div>Enter Fabric Name :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={name}
            placeholder="Fabric Name"
          />
        {/if}
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Inventory Level :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="number"
          step="any"
          bind:value={inventoryLevel}
          placeholder="Inventory Level"
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>EOQ :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="number"
          step="any"
          bind:value={reorderLevel}
          placeholder="EOQ"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Roll Number [Optional] :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={rowN}
          placeholder="Roll Number"
        />
      </div>
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Colour :</div>
        <input
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={colour}
          placeholder="Colour"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-8">
      <div class="grid grid-cols-3 gap-2 items-center">
        <div>Description :</div>
        <textarea
          class="col-span-2 shadow-sm placeholder-gray-300"
          type="text"
          bind:value={description}
          placeholder="Stock Unit Description"
          rows="2"
        />
      </div>
    </div>

    {#if uploading}
      <div class="grid grid-cols-1 gap-8">
        <div class="flex items-center justify-center btn btn-green-outline">
          <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
          <span class="ml-4">Please wait...</span>
        </div>
      </div>
    {:else}
      <!-- else content here -->
      <div class="grid grid-cols-2 gap-8">
        <button class="btn btn-green-outline" on:click={handleClear}>
          <i class="fas fa-times-circle mr-3" />
          Clear Form
        </button>
        <button class="btn btn-green">
          <i class="fas fa-check-circle mr-3" />
          Save to Database
        </button>
      </div>
    {/if}
  </form>
</Layout>
